import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class Guard {
  protected authenticationService = inject(AuthenticationService);


  public static roleCanViewAdminPolicy(roles: string[]): boolean {
    if (!roles) {
      return false;
    }
    return roles.includes('admin');
  }
}
